import ActivityIconImport from './activity.svg?react';
import AddCircleLineIconImport from './add_circle_line.svg?react';
import AddLineIconImport from './add_line.svg?react';
import ArchiveFillIconImport from './archive_fill.svg?react';
import ArchiveLineIconImport from './archive_line.svg?react';
import ArrowDownLineIconImport from './arrow_down_line.svg?react';
import ArrowLeftLineIconImport from './arrow_left_line.svg?react';
import ArrowRightDownLineIconImport from './arrow_right_down_line.svg?react';
import ArrowRightLineIconImport from './arrow_right_line.svg?react';
import ArrowRightUpLineIconImport from './arrow_right_up_line.svg?react';
import AttachmentLineIconImport from './attachment_line.svg?react';
import AudioIconImport from './audio.svg?react';
import BankFillIconImport from './bank_fill.svg?react';
import BankLineIconImport from './bank_line.svg?react';
import BellCircleIconImport from './bell-circle.svg?react';
import BellRingingFillIconImport from './bell_ringing_fill.svg?react';
import BellRingingLineIconImport from './bell_ringing_line.svg?react';
import BillLineIconImport from './bill_line.svg?react';
import Book2FillIconImport from './book_2_fill.svg?react';
import Book2LineIconImport from './book_2_line.svg?react';
import BookmarkFillIconImport from './bookmark_fill.svg?react';
import BookmarkLineIconImport from './bookmark_line.svg?react';
import BriefcaseLineIconImport from './briefcase_line.svg?react';
import BubbleLineIconImport from './bubble_line.svg?react';
import CalendarFillIconImport from './calendar_fill.svg?react';
import CalendarLineIconImport from './calendar_line.svg?react';
import CalendarMonthLineIconImport from './calendar_month_line.svg?react';
import CalendarTimeAddFillIconImport from './calendar_time_add_fill.svg?react';
import CamcorderLineIconImport from './camcorder_line.svg?react';
import Camera2LineIconImport from './camera_2_line.svg?react';
import CellphoneLineIconImport from './cellphone_line.svg?react';
import ChartLineFillIconImport from './chart_line_fill.svg?react';
import ChartLineLineIconImport from './chart_line_line.svg?react';
import Chat1FillIconImport from './chat_1_fill.svg?react';
import Chat1LineIconImport from './chat_1_line.svg?react';
import Chat3LineIconImport from './chat_3_line.svg?react';
import CheckCircleFillIconImport from './check_circle_fill.svg?react';
import CheckCircleLineIconImport from './check_circle_line.svg?react';
import CheckFillIconImport from './check_fill.svg?react';
import CheckGreenIconImport from './check_green.svg?react';
import CheckLineIconImport from './check_line.svg?react';
import ChurchLineIconImport from './church_line.svg?react';
import Classify2FillIconImport from './classify_2_fill.svg?react';
import Classify2LineIconImport from './classify_2_line.svg?react';
import CloseCircleFillIconImport from './close_circle_fill.svg?react';
import CloseCircleLineIconImport from './close_circle_line.svg?react';
import CloseLineIconImport from './close_line.svg?react';
import CodeIconImport from './code.svg?react';
import CodeLineIconImport from './code_line.svg?react';
import Comment2LineIconImport from './comment_2_line.svg?react';
import CommentLineIconImport from './comment_line.svg?react';
import CompassFillIconImport from './compass_fill.svg?react';
import CompassLineIconImport from './compass_line.svg?react';
import ComputerLineIconImport from './computer_line.svg?react';
import CopyLineIconImport from './copy_line.svg?react';
import DefaultFileIconImport from './default_file.svg?react';
import Delete2LineIconImport from './delete_2_line.svg?react';
import DocumentIconImport from './doc.svg?react';
import Document3FillIconImport from './document_3_fill.svg?react';
import Document3LineIconImport from './document_3_line.svg?react';
import DocumentLineIconImport from './document_line.svg?react';
import DotGridLineIconImport from './dot_grid_line.svg?react';
import DownLineIconImport from './down_line.svg?react';
import DownSmallLineIconImport from './down_small_line.svg?react';
import Download2LineIconImport from './download_2_line.svg?react';
import DropboxIconImport from './dropbox.svg?react';
import EarthLineIconImport from './earth_line.svg?react';
import EnterLineIconImport from './enter-line.svg?react';
import EventIconImport from './event.svg?react';
import ExchangeDollarLineIconImport from './exchange_dollar_line.svg?react';
import ExitLineIconImport from './exit_line.svg?react';
import ExternalLinkLineIconImport from './external_link_line.svg?react';
import Eye2LineIconImport from './eye_2_line.svg?react';
import EyeCloseLineIconImport from './eye_close_line.svg?react';
import EyeLineIconImport from './eye_line.svg?react';
import FbIconImport from './fb.svg?react';
import FileCheckLineIconImport from './file_check_line.svg?react';
import FileExportLineIconImport from './file_export_line.svg?react';
import FileImportLineIconImport from './file_import_line.svg?react';
import FileLineIconImport from './file_line.svg?react';
import FileSecurityLineIconImport from './file_security_line.svg?react';
import Flag1LineIconImport from './flag_1_line.svg?react';
import FlaskLineIconImport from './flask_line.svg?react';
import FolderIconImport from './folder.svg?react';
import FolderLineIconImport from './folder_line.svg?react';
import FoldersFillIconImport from './folders_fill.svg?react';
import FoldersLineIconImport from './folders_line.svg?react';
import ForbidCircleLineIconImport from './forbid_circle_line.svg?react';
import GameIconImport from './game.svg?react';
import Game1LineIconImport from './game_1_line.svg?react';
import GitMergeLineIconImport from './git_merge_line.svg?react';
import GridLineIconImport from './grid_line.svg?react';
import GroupFillIconImport from './group_fill.svg?react';
import GroupLineIconImport from './group_line.svg?react';
import HandHeartFillIconImport from './hand_heart_fill.svg?react';
import HandHeartLineIconImport from './hand_heart_line.svg?react';
import HeartFillIconImport from './heart_fill.svg?react';
import HeartLineIconImport from './heart_line.svg?react';
import HeartbeatIconImport from './heartbeat.svg?react';
import HeartbeatLineIconImport from './heartbeat_line.svg?react';
import HistoryLineIconImport from './history_line.svg?react';
import Home4FillIconImport from './home_4_fill.svg?react';
import Home4LineIconImport from './home_4_line.svg?react';
import HornLineIconImport from './horn_line.svg?react';
import HospitalLineIconImport from './hospital_line.svg?react';
import { withAntIconWrapper } from './icon-wrapper';
import ImgIconImport from './img.svg?react';
import Inbox2LineIconImport from './inbox_2_line.svg?react';
import InboxLineIconImport from './inbox_line.svg?react';
import InboxLineCircleIconImport from './inbox_line_circle.svg?react';
import InformationFillIconImport from './information_fill.svg?react';
import InformationLineIconImport from './information_line.svg?react';
import InviteIconImport from './invite.svg?react';
import Key2LineIconImport from './key_2_line.svg?react';
import LayoutGridLineIconImport from './layout_grid_line.svg?react';
import LayoutLeftFillIconImport from './layout_left_fill.svg?react';
import LayoutLeftLineIconImport from './layout_left_line.svg?react';
import LeftLineIconImport from './left_line.svg?react';
import LightLineIconImport from './light_line.svg?react';
import Link2LineIconImport from './link_2_line.svg?react';
import LinkLineIconImport from './link_line.svg?react';
import LinkedinIconImport from './linkedin.svg?react';
import ListCheckIconImport from './list-check.svg?react';
import ListCircleIconImport from './list-circle.svg?react';
import ListCheck3LineIconImport from './list_check_3_line.svg?react';
import ListCheckLineIconImport from './list_check_line.svg?react';
import LoadingLineIconImport from './loading_line.svg?react';
import LocationLineIconImport from './location_line.svg?react';
import LockLineIconImport from './lock_line.svg?react';
import MailFillIconImport from './mail_fill.svg?react';
import MailLineIconImport from './mail_line.svg?react';
import MailSendLineIconImport from './mail_send_line.svg?react';
import MedalLineIconImport from './medal_line.svg?react';
import Message2LineIconImport from './message_2_line.svg?react';
import MessagesCircleIconImport from './messages-circle.svg?react';
import MinusCircleFillIconImport from './minus_circle_fill.svg?react';
import MinusCircleLineIconImport from './minus_circle_line.svg?react';
import More2LineIconImport from './more_2_line.svg?react';
import MortarboardFillIconImport from './mortarboard_fill.svg?react';
import MortarboardLineIconImport from './mortarboard_line.svg?react';
import NewFolderLineIconImport from './new_folder_line.svg?react';
import Notebook2FillIconImport from './notebook_2_fill.svg?react';
import Notebook2LineIconImport from './notebook_2_line.svg?react';
import NotificationFillIconImport from './notification_fill.svg?react';
import NotificationLineIconImport from './notification_line.svg?react';
import NotificationOffLineIconImport from './notification_off_line.svg?react';
import PdfIconImport from './pdf.svg?react';
import PencilLineIconImport from './pencil_line.svg?react';
import PhoneFillIconImport from './phone_fill.svg?react';
import PhoneLineIconImport from './phone_line.svg?react';
import PicLineIconImport from './pic_line.svg?react';
import Pin2FillIconImport from './pin_2_fill.svg?react';
import Pin2LineIconImport from './pin_2_line.svg?react';
import PinLineIconImport from './pin_line.svg?react';
import PlayButtonIconImport from './play_button.svg?react';
import PlayCircleFillIconImport from './play_circle_fill.svg?react';
import PlayLineIconImport from './play_line.svg?react';
import PollIconImport from './poll.svg?react';
import PostIconImport from './post.svg?react';
import PptIconImport from './ppt.svg?react';
import Presentation1LineIconImport from './presentation_1_line.svg?react';
import Presentation2LineIconImport from './presentation_2_line.svg?react';
import QrcodeLineIconImport from './qrcode_line.svg?react';
import QuestionFillIconImport from './question_fill.svg?react';
import QuestionLineIconImport from './question_line.svg?react';
import RadarLineIconImport from './radar_line.svg?react';
import Refresh1LineIconImport from './refresh_1_line.svg?react';
import Refresh4LineIconImport from './refresh_4_line.svg?react';
import RepeatLineIconImport from './repeat_line.svg?react';
import RightLineIconImport from './right_line.svg?react';
import RocketLineIconImport from './rocket_line.svg?react';
import RoundFillIconImport from './round_fill.svg?react';
import RoundLineIconImport from './round_line.svg?react';
import SadFaceIconImport from './sad-face.svg?react';
import SafeShield2FillIconImport from './safe_shield_2_fill.svg?react';
import Search2LineIconImport from './search_2_line.svg?react';
import SendLineIconImport from './send_line.svg?react';
import SendPlaneLineIconImport from './send_plane_line.svg?react';
import Settings5LineIconImport from './settings_5_line.svg?react';
import ShareForwardLineIconImport from './share_forward_line.svg?react';
import SheetIconImport from './sheet.svg?react';
import ShieldShapeLineIconImport from './shield_shape_line.svg?react';
import SitemapLineIconImport from './sitemap_line.svg?react';
import StarLineIconImport from './star_line.svg?react';
import StopCircleFillIconImport from './stop_circle_fill.svg?react';
import StopCircleLineIconImport from './stop_circle_line.svg?react';
import Tag2LineIconImport from './tag_2_line.svg?react';
import Tag2LineCircleIconImport from './tag_2_line_circle.svg?react';
import TagChevronLineIconImport from './tag_chevron_line.svg?react';
import TagLineIconImport from './tag_line.svg?react';
import TelehealthLineIconImport from './telehealth_line.svg?react';
import TimeFillIconImport from './time_fill.svg?react';
import TimeLineIconImport from './time_line.svg?react';
import ToolFillIconImport from './tool_fill.svg?react';
import ToolLineIconImport from './tool_line.svg?react';
import Transfer3LineIconImport from './transfer_3_line.svg?react';
import UpLineIconImport from './up_line.svg?react';
import Upload2LineIconImport from './upload_2_line.svg?react';
import User1LineIconImport from './user_1_line.svg?react';
import User3LineIconImport from './user_3_line.svg?react';
import User4LineIconImport from './user_4_line.svg?react';
import UserAddLineIconImport from './user_add_line.svg?react';
import UserEditLineIconImport from './user_edit_line.svg?react';
import UserRemoveLineIconImport from './user_remove_line.svg?react';
import UserSecurityLineIconImport from './user_security_line.svg?react';
import VersionFillIconImport from './version_fill.svg?react';
import VideoIconImport from './video.svg?react';
import VideoFillIconImport from './video_fill.svg?react';
import VideoLineIconImport from './video_line.svg?react';
import WarningFillIconImport from './warning_fill.svg?react';
import WarningLineIconImport from './warning_line.svg?react';
import WithingsOrderPostIconImport from './withings_order_post.svg?react';
import ZipIconImport from './zip.svg?react';

export const icons = {
  activity: withAntIconWrapper(ActivityIconImport),
  'add-circle-line': withAntIconWrapper(AddCircleLineIconImport),
  'add-line': withAntIconWrapper(AddLineIconImport),
  'archive-fill': withAntIconWrapper(ArchiveFillIconImport),
  'archive-line': withAntIconWrapper(ArchiveLineIconImport),
  'arrow-down-line': withAntIconWrapper(ArrowDownLineIconImport),
  'arrow-left-line': withAntIconWrapper(ArrowLeftLineIconImport),
  'arrow-right-down-line': withAntIconWrapper(ArrowRightDownLineIconImport),
  'arrow-right-line': withAntIconWrapper(ArrowRightLineIconImport),
  'arrow-right-up-line': withAntIconWrapper(ArrowRightUpLineIconImport),
  'attachment-line': withAntIconWrapper(AttachmentLineIconImport),
  'audio-file': withAntIconWrapper(AudioIconImport),
  'bank-fill': withAntIconWrapper(BankFillIconImport),
  'bank-line': withAntIconWrapper(BankLineIconImport),
  'bell-circle': withAntIconWrapper(BellCircleIconImport),
  'bell-ringing-fill': withAntIconWrapper(BellRingingFillIconImport),
  'bell-ringing-line': withAntIconWrapper(BellRingingLineIconImport),
  'bill-line': withAntIconWrapper(BillLineIconImport),
  'book-2-fill': withAntIconWrapper(Book2FillIconImport),
  'book-2-line': withAntIconWrapper(Book2LineIconImport),
  'bookmark-fill': withAntIconWrapper(BookmarkFillIconImport),
  'bookmark-line': withAntIconWrapper(BookmarkLineIconImport),
  'briefcase-line': withAntIconWrapper(BriefcaseLineIconImport),
  'bubble-line': withAntIconWrapper(BubbleLineIconImport),
  'calendar-fill': withAntIconWrapper(CalendarFillIconImport),
  'calendar-line': withAntIconWrapper(CalendarLineIconImport),
  'calendar-month-line': withAntIconWrapper(CalendarMonthLineIconImport),
  'calendar-time-add-fill': withAntIconWrapper(CalendarTimeAddFillIconImport),
  'camcorder-line': withAntIconWrapper(CamcorderLineIconImport),
  'camera-2-line': withAntIconWrapper(Camera2LineIconImport),
  'cellphone-line': withAntIconWrapper(CellphoneLineIconImport),
  'chart-line-fill': withAntIconWrapper(ChartLineFillIconImport),
  'chart-line-line': withAntIconWrapper(ChartLineLineIconImport),
  'chat-1-fill': withAntIconWrapper(Chat1FillIconImport),
  'chat-1-line': withAntIconWrapper(Chat1LineIconImport),
  'chat-3-line': withAntIconWrapper(Chat3LineIconImport),
  'check-circle-fill': withAntIconWrapper(CheckCircleFillIconImport),
  'check-circle-line': withAntIconWrapper(CheckCircleLineIconImport),
  'check-fill': withAntIconWrapper(CheckFillIconImport),
  'check-green': withAntIconWrapper(CheckGreenIconImport),
  'check-line': withAntIconWrapper(CheckLineIconImport),
  'church-line': withAntIconWrapper(ChurchLineIconImport),
  'classify-2-fill': withAntIconWrapper(Classify2FillIconImport),
  'classify-2-line': withAntIconWrapper(Classify2LineIconImport),
  'close-circle-fill': withAntIconWrapper(CloseCircleFillIconImport),
  'close-circle-line': withAntIconWrapper(CloseCircleLineIconImport),
  'close-line': withAntIconWrapper(CloseLineIconImport),
  'code-file': withAntIconWrapper(CodeIconImport),
  'code-line': withAntIconWrapper(CodeLineIconImport),
  'comment-2-line': withAntIconWrapper(Comment2LineIconImport),
  'comment-line': withAntIconWrapper(CommentLineIconImport),
  'compass-fill': withAntIconWrapper(CompassFillIconImport),
  'compass-line': withAntIconWrapper(CompassLineIconImport),
  'computer-line': withAntIconWrapper(ComputerLineIconImport),
  'copy-line': withAntIconWrapper(CopyLineIconImport),
  'default-file': withAntIconWrapper(DefaultFileIconImport),
  'delete-2-line': withAntIconWrapper(Delete2LineIconImport),
  'document-3-fill': withAntIconWrapper(Document3FillIconImport),
  'document-3-line': withAntIconWrapper(Document3LineIconImport),
  'document-file': withAntIconWrapper(DocumentIconImport),
  'document-line': withAntIconWrapper(DocumentLineIconImport),
  'dot-grid-line': withAntIconWrapper(DotGridLineIconImport),
  'down-line': withAntIconWrapper(DownLineIconImport),
  'down-small-line': withAntIconWrapper(DownSmallLineIconImport),
  'download-2-line': withAntIconWrapper(Download2LineIconImport),
  dropbox: withAntIconWrapper(DropboxIconImport),
  'earth-line': withAntIconWrapper(EarthLineIconImport),
  'enter-line': withAntIconWrapper(EnterLineIconImport),
  event: withAntIconWrapper(EventIconImport),
  'exchange-dollar-line': withAntIconWrapper(ExchangeDollarLineIconImport),
  'exit-line': withAntIconWrapper(ExitLineIconImport),
  'external-link-line': withAntIconWrapper(ExternalLinkLineIconImport),
  'eye-2-line': withAntIconWrapper(Eye2LineIconImport),
  'eye-close-line': withAntIconWrapper(EyeCloseLineIconImport),
  'eye-line': withAntIconWrapper(EyeLineIconImport),
  fb: withAntIconWrapper(FbIconImport),
  'file-check-line': withAntIconWrapper(FileCheckLineIconImport),
  'file-export-line': withAntIconWrapper(FileExportLineIconImport),
  'file-import-line': withAntIconWrapper(FileImportLineIconImport),
  'file-line': withAntIconWrapper(FileLineIconImport),
  'file-security-line': withAntIconWrapper(FileSecurityLineIconImport),
  'flag-1-line': withAntIconWrapper(Flag1LineIconImport),
  'flask-line': withAntIconWrapper(FlaskLineIconImport),
  folder: withAntIconWrapper(FolderIconImport),
  'folder-line': withAntIconWrapper(FolderLineIconImport),
  'folders-fill': withAntIconWrapper(FoldersFillIconImport),
  'folders-line': withAntIconWrapper(FoldersLineIconImport),
  'forbid-circle-line': withAntIconWrapper(ForbidCircleLineIconImport),
  game: withAntIconWrapper(GameIconImport),
  'game-1-line': withAntIconWrapper(Game1LineIconImport),
  'git-merge-line': withAntIconWrapper(GitMergeLineIconImport),
  'grid-line': withAntIconWrapper(GridLineIconImport),
  'group-fill': withAntIconWrapper(GroupFillIconImport),
  'group-line': withAntIconWrapper(GroupLineIconImport),
  'hand-heart-fill': withAntIconWrapper(HandHeartFillIconImport),
  'hand-heart-line': withAntIconWrapper(HandHeartLineIconImport),
  'heart-fill': withAntIconWrapper(HeartFillIconImport),
  'heart-line': withAntIconWrapper(HeartLineIconImport),
  heartbeat: withAntIconWrapper(HeartbeatIconImport),
  'heartbeat-line': withAntIconWrapper(HeartbeatLineIconImport),
  'history-line': withAntIconWrapper(HistoryLineIconImport),
  'home-4-fill': withAntIconWrapper(Home4FillIconImport),
  'home-4-line': withAntIconWrapper(Home4LineIconImport),
  'horn-line': withAntIconWrapper(HornLineIconImport),
  'hospital-line': withAntIconWrapper(HospitalLineIconImport),
  'img-file': withAntIconWrapper(ImgIconImport),
  'inbox-2-line': withAntIconWrapper(Inbox2LineIconImport),
  'inbox-line': withAntIconWrapper(InboxLineIconImport),
  'inbox-line-circle': withAntIconWrapper(InboxLineCircleIconImport),
  'information-fill': withAntIconWrapper(InformationFillIconImport),
  'information-line': withAntIconWrapper(InformationLineIconImport),
  invite: withAntIconWrapper(InviteIconImport),
  'key-2-line': withAntIconWrapper(Key2LineIconImport),
  'layout-grid-line': withAntIconWrapper(LayoutGridLineIconImport),
  'layout-left-fill': withAntIconWrapper(LayoutLeftFillIconImport),
  'layout-left-line': withAntIconWrapper(LayoutLeftLineIconImport),
  'left-line': withAntIconWrapper(LeftLineIconImport),
  'light-line': withAntIconWrapper(LightLineIconImport),
  'link-2-line': withAntIconWrapper(Link2LineIconImport),
  'link-line': withAntIconWrapper(LinkLineIconImport),
  linkedin: withAntIconWrapper(LinkedinIconImport),
  'list-check': withAntIconWrapper(ListCheckIconImport),
  'list-check-3-line': withAntIconWrapper(ListCheck3LineIconImport),
  'list-check-line': withAntIconWrapper(ListCheckLineIconImport),
  'list-circle': withAntIconWrapper(ListCircleIconImport),
  'loading-line': withAntIconWrapper(LoadingLineIconImport),
  'location-line': withAntIconWrapper(LocationLineIconImport),
  'lock-line': withAntIconWrapper(LockLineIconImport),
  'mail-fill': withAntIconWrapper(MailFillIconImport),
  'mail-line': withAntIconWrapper(MailLineIconImport),
  'mail-send-line': withAntIconWrapper(MailSendLineIconImport),
  'medal-line': withAntIconWrapper(MedalLineIconImport),
  'message-2-line': withAntIconWrapper(Message2LineIconImport),
  'messages-circle': withAntIconWrapper(MessagesCircleIconImport),
  'minus-circle-fill': withAntIconWrapper(MinusCircleFillIconImport),
  'minus-circle-line': withAntIconWrapper(MinusCircleLineIconImport),
  'more-2-line': withAntIconWrapper(More2LineIconImport),
  'mortarboard-fill': withAntIconWrapper(MortarboardFillIconImport),
  'mortarboard-line': withAntIconWrapper(MortarboardLineIconImport),
  'new-folder-line': withAntIconWrapper(NewFolderLineIconImport),
  'notebook-2-fill': withAntIconWrapper(Notebook2FillIconImport),
  'notebook-2-line': withAntIconWrapper(Notebook2LineIconImport),
  'notification-fill': withAntIconWrapper(NotificationFillIconImport),
  'notification-line': withAntIconWrapper(NotificationLineIconImport),
  'notification-off-line': withAntIconWrapper(NotificationOffLineIconImport),
  'pdf-file': withAntIconWrapper(PdfIconImport),
  'pencil-line': withAntIconWrapper(PencilLineIconImport),
  'phone-fill': withAntIconWrapper(PhoneFillIconImport),
  'phone-line': withAntIconWrapper(PhoneLineIconImport),
  'pic-line': withAntIconWrapper(PicLineIconImport),
  'pin-2-fill': withAntIconWrapper(Pin2FillIconImport),
  'pin-2-line': withAntIconWrapper(Pin2LineIconImport),
  'pin-line': withAntIconWrapper(PinLineIconImport),
  'play-button': withAntIconWrapper(PlayButtonIconImport),
  'play-circle-fill': withAntIconWrapper(PlayCircleFillIconImport),
  'play-line': withAntIconWrapper(PlayLineIconImport),
  poll: withAntIconWrapper(PollIconImport),
  post: withAntIconWrapper(PostIconImport),
  'ppt-file': withAntIconWrapper(PptIconImport),
  'presentation-1-line': withAntIconWrapper(Presentation1LineIconImport),
  'presentation-2-line': withAntIconWrapper(Presentation2LineIconImport),
  'qrcode-line': withAntIconWrapper(QrcodeLineIconImport),
  'question-fill': withAntIconWrapper(QuestionFillIconImport),
  'question-line': withAntIconWrapper(QuestionLineIconImport),
  'radar-line': withAntIconWrapper(RadarLineIconImport),
  'refresh-1-line': withAntIconWrapper(Refresh1LineIconImport),
  'refresh-4-line': withAntIconWrapper(Refresh4LineIconImport),
  'repeat-line': withAntIconWrapper(RepeatLineIconImport),
  'right-line': withAntIconWrapper(RightLineIconImport),
  'rocket-line': withAntIconWrapper(RocketLineIconImport),
  'round-fill': withAntIconWrapper(RoundFillIconImport),
  'round-line': withAntIconWrapper(RoundLineIconImport),
  'sad-face': withAntIconWrapper(SadFaceIconImport),
  'safe-shield-2-fill': withAntIconWrapper(SafeShield2FillIconImport),
  'search-2-line': withAntIconWrapper(Search2LineIconImport),
  'send-line': withAntIconWrapper(SendLineIconImport),
  'send-plane-line': withAntIconWrapper(SendPlaneLineIconImport),
  'settings-5-line': withAntIconWrapper(Settings5LineIconImport),
  'share-forward-line': withAntIconWrapper(ShareForwardLineIconImport),
  'sheet-file': withAntIconWrapper(SheetIconImport),
  'shield-shape-line': withAntIconWrapper(ShieldShapeLineIconImport),
  'sitemap-line': withAntIconWrapper(SitemapLineIconImport),
  'star-line': withAntIconWrapper(StarLineIconImport),
  'stop-circle-fill': withAntIconWrapper(StopCircleFillIconImport),
  'stop-circle-line': withAntIconWrapper(StopCircleLineIconImport),
  'tag-2-line': withAntIconWrapper(Tag2LineIconImport),
  'tag-2-line-circle': withAntIconWrapper(Tag2LineCircleIconImport),
  'tag-chevron-line': withAntIconWrapper(TagChevronLineIconImport),
  'tag-line': withAntIconWrapper(TagLineIconImport),
  'telehealth-line': withAntIconWrapper(TelehealthLineIconImport),
  'time-fill': withAntIconWrapper(TimeFillIconImport),
  'time-line': withAntIconWrapper(TimeLineIconImport),
  'tool-fill': withAntIconWrapper(ToolFillIconImport),
  'tool-line': withAntIconWrapper(ToolLineIconImport),
  'transfer-3-line': withAntIconWrapper(Transfer3LineIconImport),
  'up-line': withAntIconWrapper(UpLineIconImport),
  'upload-2-line': withAntIconWrapper(Upload2LineIconImport),
  'user-1-line': withAntIconWrapper(User1LineIconImport),
  'user-3-line': withAntIconWrapper(User3LineIconImport),
  'user-4-line': withAntIconWrapper(User4LineIconImport),
  'user-add-line': withAntIconWrapper(UserAddLineIconImport),
  'user-edit-line': withAntIconWrapper(UserEditLineIconImport),
  'user-remove-line': withAntIconWrapper(UserRemoveLineIconImport),
  'user-security-line': withAntIconWrapper(UserSecurityLineIconImport),
  'version-fill': withAntIconWrapper(VersionFillIconImport),
  'video-file': withAntIconWrapper(VideoIconImport),
  'video-fill': withAntIconWrapper(VideoFillIconImport),
  'video-line': withAntIconWrapper(VideoLineIconImport),
  'warning-fill': withAntIconWrapper(WarningFillIconImport),
  'warning-line': withAntIconWrapper(WarningLineIconImport),
  'withings-order-post': withAntIconWrapper(WithingsOrderPostIconImport),
  'zip-file': withAntIconWrapper(ZipIconImport),
} as const;

export type IconName = keyof typeof icons;
